<a (click)="toggle()" type="button"><ng-content></ng-content> <span [ngClass]="{'fa-chevron-left': expanded, 'fa-chevron-down': !expanded}" class="fa"></span></a>
<div [@openClose]="expanded">
  <ng-content select="ul"></ng-content>
</div>
